import React, { useState, useEffect } from "react";
import imageProfile from "../assets/images/pasfoto.png";

const Home = () => {
  const [activeCodeTab, setActiveCodeTab] = useState("stack");
  const [latency, setLatency] = useState(18);
  const [uptime, setUptime] = useState(99.99);

  // Live network latency simulation
  useEffect(() => {
    const interval = setInterval(() => {
      setLatency(Math.floor(14 + Math.random() * 8));
      setUptime(parseFloat((99.98 + Math.random() * 0.015).toFixed(2)));
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="home" className="relative pt-36 pb-24 bg-slate-950 text-slate-100 overflow-hidden bg-cyber-grid">
      {/* Cyber Ambient Glow Orbs */}
      <div className="absolute top-1/4 left-10 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none animate-pulse-emerald" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none animate-pulse-indigo" />

      {/* Top Cyber Status Bar */}
      <div className="container mx-auto px-4 mb-8">
        <div className="flex flex-wrap items-center justify-between gap-4 p-4 rounded-2xl bg-slate-900/80 border border-emerald-500/30 backdrop-blur-md shadow-2xl">
          <div className="flex items-center gap-3">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500" />
            </span>
            <span className="font-mono text-xs font-bold text-emerald-400 tracking-wider uppercase">
              💻 FULL-STACK SOFTWARE ENGINEER TERMINAL :: PRODUCTION VERCEL STREAM
            </span>
          </div>

          <div className="flex items-center gap-6 text-xs font-mono text-slate-300">
            <div>
              <span className="text-slate-500">CLOUD NODE:</span>{" "}
              <span className="text-emerald-400 font-bold">ACTIVE (SG-SIN1)</span>
            </div>
            <div>
              <span className="text-slate-500">API LATENCY:</span>{" "}
              <span className="text-cyan-400 font-bold">{latency} ms</span>
            </div>
            <div>
              <span className="text-slate-500">SYSTEM UPTIME:</span>{" "}
              <span className="text-indigo-400 font-bold">{uptime}%</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center">
          {/* Left Column: Authentic Bio & Core Tech Stack */}
          <div className="w-full self-center px-4 lg:w-7/12 mb-12 lg:mb-0">
            {/* Tech Pill Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/40 text-emerald-400 text-xs font-mono font-bold uppercase tracking-widest mb-6 shadow-lg shadow-emerald-500/10 animate-float-cyber">
              <span>🚀 SENIOR FULL-STACK SOFTWARE ENGINEER &amp; LEAD PM / BUSINESS ANALYST</span>
            </div>

            <h1 className="text-3xl font-black text-slate-100 sm:text-5xl lg:text-6xl tracking-tight leading-tight mb-4">
              Muhammad Haidar <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-teal-300 to-indigo-400">Shahab</span>
            </h1>

            <h2 className="text-base font-bold text-slate-300 sm:text-lg lg:text-xl mb-6 font-mono leading-relaxed">
              <span className="text-white font-extrabold">Senior Full-Stack Software Engineer &amp; Lead Project Management / Business Analyst</span> |{" "}
              <span className="text-emerald-400">Industry-Standard Adaptive Engineer with Practical AI Workflow &amp; Hardware Integration Experience</span>
            </h2>

            <p className="mb-8 font-normal leading-relaxed text-slate-300 text-base lg:text-lg max-w-2xl">
              Working as a dedicated <strong className="text-white">Senior Full-Stack Software Engineer</strong> specializing in modern web ecosystems (<code className="text-emerald-400 font-mono">TypeScript, React.js, Next.js, Node.js, NestJS, and Laravel</code>), paired with proven <strong className="text-white">Project Management &amp; Business Analyst leadership</strong> (PT Bukit Asam internal MII team). Possess an industry-standard adaptability mindset—open to rapid framework shifts and seamlessly collaborating with enterprise cloud-native backend standards (<code className="text-teal-300 font-mono">Java Quarkus + BPMN Workflow</code>) across high-concurrency BUMN and FinTech environments.
            </p>

            {/* IT Performance Badges Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-10">
              <div className="p-3.5 rounded-2xl bg-slate-900/60 border border-emerald-500/30 backdrop-blur-md">
                <div className="text-2xl font-black text-emerald-400 font-mono">±5 Yrs</div>
                <div className="text-[11px] text-slate-400 font-semibold uppercase tracking-wider">Production Track Record</div>
              </div>
              <div className="p-3.5 rounded-2xl bg-slate-900/60 border border-indigo-500/30 backdrop-blur-md">
                <div className="text-2xl font-black text-indigo-400 font-mono">18+</div>
                <div className="text-[11px] text-slate-400 font-semibold uppercase tracking-wider">Production Systems</div>
              </div>
              <div className="p-3.5 rounded-2xl bg-slate-900/60 border border-teal-500/30 backdrop-blur-md col-span-2 sm:col-span-1">
                <div className="text-2xl font-black text-teal-300 font-mono">100%</div>
                <div className="text-[11px] text-slate-400 font-semibold uppercase tracking-wider">Full-Stack TS / Node / Nest</div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-wrap gap-4 items-center">
              <a
                href="#portfolio"
                className="px-8 py-4 rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-slate-950 font-extrabold text-sm uppercase tracking-wider shadow-lg shadow-emerald-500/30 transition-all duration-300 hover:scale-105"
              >
                💻 Explore Software Products
              </a>
              <a
                href="#contact"
                className="px-8 py-4 rounded-2xl bg-slate-900/80 hover:bg-slate-800 border border-indigo-500/40 text-indigo-300 font-extrabold text-sm uppercase tracking-wider shadow-lg transition-all duration-300 hover:scale-105"
              >
                📡 Contact Me
              </a>
            </div>
          </div>

          {/* Right Column: Interactive Code Terminal Widget */}
          <div className="w-full self-center px-4 lg:w-5/12">
            <div className="relative mx-auto max-w-md">
              {/* Cyber Frame Container */}
              <div className="cyber-card relative z-10 p-5 rounded-3xl overflow-hidden shadow-2xl border-2 border-emerald-500/40 animate-pulse-emerald">
                {/* Terminal Header */}
                <div className="flex items-center justify-between pb-3 mb-3 border-b border-slate-800">
                  <div className="flex items-center gap-2">
                    <span className="h-3 w-3 rounded-full bg-red-500 inline-block" />
                    <span className="h-3 w-3 rounded-full bg-amber-500 inline-block" />
                    <span className="h-3 w-3 rounded-full bg-emerald-500 inline-block" />
                  </div>
                  <span className="font-mono text-xs text-slate-400 font-bold">engineer_profile.ts</span>
                </div>

                {/* Profile Image & Cyber Scanline */}
                <div className="relative overflow-hidden rounded-2xl bg-slate-950 p-2 mb-4 border border-slate-800">
                  <img
                    src={imageProfile}
                    alt="Muhammad Haidar Shahab"
                    className="w-full h-[320px] object-contain object-center drop-shadow-2xl transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-500/10 to-transparent h-12 w-full animate-scanline pointer-events-none" />
                </div>

                {/* Interactive Code Selector */}
                <div className="flex flex-col gap-2">
                  <div className="text-[10px] font-mono text-emerald-400 uppercase tracking-widest text-center font-bold">
                    SELECT INTERACTIVE CODE SPECIFICATION:
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    <button
                      type="button"
                      onClick={() => setActiveCodeTab("stack")}
                      className={`p-2 rounded-xl text-[11px] font-mono font-bold transition-all ${
                        activeCodeTab === "stack"
                          ? "bg-emerald-500 text-slate-950 shadow-md shadow-emerald-500/30"
                          : "bg-slate-900 text-slate-400 hover:bg-slate-800"
                      }`}
                    >
                      Tech Stack
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveCodeTab("ai")}
                      className={`p-2 rounded-xl text-[11px] font-mono font-bold transition-all ${
                        activeCodeTab === "ai"
                          ? "bg-indigo-500 text-white shadow-md shadow-indigo-500/30"
                          : "bg-slate-900 text-slate-400 hover:bg-slate-800"
                      }`}
                    >
                      My Agent AI
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveCodeTab("bumn")}
                      className={`p-2 rounded-xl text-[11px] font-mono font-bold transition-all ${
                        activeCodeTab === "bumn"
                          ? "bg-teal-400 text-slate-950 shadow-md shadow-teal-400/30"
                          : "bg-slate-900 text-slate-400 hover:bg-slate-800"
                      }`}
                    >
                      BUMN Microservices
                    </button>
                  </div>

                  {/* Terminal Code Readout */}
                  <pre className="p-3.5 rounded-xl bg-slate-950 border border-slate-800 font-mono text-[11px] text-slate-300 leading-relaxed overflow-x-auto selection:bg-emerald-900 selection:text-white">
                    {activeCodeTab === "stack" && (
                      <code className="text-emerald-400">
                        {`const stack = {
  role: "Senior Full-Stack Software Engineer",
  frontend: ["TypeScript", "Next.js", "React.js", "Tailwind CSS"],
  backend: ["Node.js", "NestJS", "Laravel", "Java Quarkus"],
  databases: ["PostgreSQL", "MySQL", "MongoDB", "Redis"]
};`}
                      </code>
                    )}
                    {activeCodeTab === "ai" && (
                      <code className="text-indigo-300">
                        {`const aiSuite = {
  appName: "My Agent — Autonomous Career OS",
  features: ["Stealth AI Copilot", "Puppeteer ATS Engine", "Multi-Key Load Balancer"],
  liveProduction: "https://my-agent-mauve-omega.vercel.app/"
};`}
                      </code>
                    )}
                    {activeCodeTab === "bumn" && (
                      <code className="text-teal-300">
                        {`const bumn = {
  bukitAsam: "CISEA v2.0.0 (Internal MII PM/BA & Engineer)",
  ifgLife: "Corporate LifeHub (Java Quarkus + BPMN Workflow)",
  pupukSriwidjaja: "Pusri HCMS & Operational Portals"
};`}
                      </code>
                    )}
                  </pre>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
